import React from "react";
import { Link } from "react-router-dom";

import ManagerHomeImg from "../../../assets/images/manager-home.png";
// import VideoJS from "../../../atoms/VideoJS";

import { Context } from "../../../managerStore";

import styles from "./HomePage.module.scss";

// const videoUrl = `${process.env.REACT_APP_MANAGER_APP_URL}/movie/help/manager_tutorial/manager_tutorial`;

const HomePage = () => {
  const { state } = React.useContext(Context);
  return (
    <div className={styles.wrapper}>
      <h3>はじめに</h3>
      <div className={styles.content}>
        <p>
          こちらはENAGEEDサービス学校管理者画面です。以下3つのサービスの設定を行うことができます。
        </p>
        <img src={ManagerHomeImg} alt="homepage" />
      </div>
      <div className={styles.tablet}>
        <section>
          <h5>● 授業開始までの流れ</h5>
          <p>
            1. メニューの「<Link to="/teachers">先生登録</Link>
            」より、ENAGEED教材を使う先生をご登録ください。
          </p>
          <p>
            2. メニューの「<Link to="/classes">クラス登録</Link>
            」より、ENAGEEDを行うクラスを登録してください。
          </p>
          <p>
            3. メニューの「
            <Link to="/students">
              {state.manager.school?.use_case === "cram_school"
                ? "生徒管理"
                : "生徒登録"}
            </Link>
            」 より、生徒を登録してください。
          </p>
          <p>
            上記を実施していただきますと、クラス、先生、生徒の情報がLOUNGE、CORE、GEARに自動的に登録されます。
          </p>
          <p>
            ※紙教材を利用する学校様でも、デジタルツールはご使用いただけます。クラス、先生、生徒をご登録ください。
          </p>
        </section>
        <section>
          <h5>● LOUNGE（先生画面のTOPページ）のみに必要な設定</h5>
          <p>
            1. メニュー「<Link to="/lounge_setting">LOUNGE設定</Link>
            」より、「ENAGEED 生成AI利用に関するガイドライン」をご確認後、
            <br />
            「AIによる振り返り要約・授業フィードバック機能を利用する」を「ON」にしてください。
          </p>
          <p>
            2. メニュー「
            <Link to="/subjects">教科を登録</Link>
            」より、先生の担当教科ををご登録ください。
          </p>
          <p>
            3. メニュー「
            <Link to="/upload_student_real_photos">生徒顔写真登録</Link>
            」より、生徒の顔写真をご登録ください。（任意）
          </p>
        </section>
        <section>
          <h5>● 学校管理画面のGEAR（振り返りツール）の機能のご紹介</h5>
          <p>
            ・メニュー「<Link to="/gear_status">GEAR利用状況</Link>
            」より、随時利用状況をご確認いただけます。
          </p>
          <p>
            ・クラス単位以外のグループを作りたい場合、メニュー「
            <Link to="/sub_classes">GEARグループの登録</Link>
            」からグループが作れます。
          </p>
          <p>
            ・クラスにお知らせしたい場合、「
            <Link to="/notifications">お知らせ追加・編集</Link>」より可能です。
          </p>
        </section>
        <div className={styles.termsUser}>
          本サービスのご利用は、契約者様が&nbsp;
          <a
            rel="noopener noreferrer"
            href="https://www.enageed.jp/hubfs/digital-teaching-materials-user-policy.pdf"
            target="_blank"
          >
            ENAGEEDデジタル版教材利用規約
          </a>
          &nbsp;および&nbsp;
          <a
            rel="noopener noreferrer"
            href="https://www.enageed.jp/hubfs/privacy/user-policy.pdf"
            target="_blank"
          >
            利用者情報の取り扱いについて
          </a>
          &nbsp;へご同意されたことを前提としております。
        </div>
        {/*解説動画が最新にアップデートされるまでは非表示*/}
        {/*<p className={styles.videotext}>*/}
        {/*  以下、学校管理者画面についての解説動画です。*/}
        {/*  <br />*/}
        {/*  先生登録の仕方 - 0分10秒*/}
        {/*  <br />*/}
        {/*  クラス登録の仕方 - 0分48秒*/}
        {/*  <br />*/}
        {/*  生徒登録の仕方 - 1分45秒 <br />*/}
        {/*  生徒IDとパスワードの発行方法 - 4分02秒*/}
        {/*  <br />*/}
        {/*  年度更新の方法 - 4分47秒*/}
        {/*</p>*/}
        {/*<div className={styles.videoItem}>*/}
        {/*  <VideoJS sourceUrl={videoUrl} />*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

export default HomePage;
